import React from "react";
import { useState } from "react";
import emailjs from "emailjs-com";
import { useLanguage } from "../context/LanguageContext";

export const ContactMe = () => {

    const { t } = useLanguage();

    const [form, setForm] = useState({
        name: "",
        email: "",
        message: ""
    });

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.send(
            "service_qrke2nx",
            "template_hrlpozv",
            {
                name: form.name,
                email: form.email,
                message: form.message,
                time: new Date().toLocaleString()
            },
            "uq_zGAYSRaQu4Yb6c"
        )
        .then(() => {
            alert(t.contactme.alert1);
            setForm({ name: "", email: "", message: "" });
        })
        .catch((err) => {
            console.log(err);
            alert(t.contactme.alert2);
        });
    };

return (
    <div className="contactme-container" id="contactme">
        <h1>{t.contactme.contacTitle}</h1>

        <form onSubmit={sendEmail} className="contact-form">

            <input 
                type="text" 
                placeholder={t.contactme.name}
                value={form.name}
                onChange={(e) => setForm({...form, name: e.target.value})}
                required
            />

            <input 
                type="email" 
                placeholder={t.contactme.mail}
                value={form.email}
                onChange={(e) => setForm({...form, email: e.target.value})}
                required
            />

            <textarea 
                placeholder={t.contactme.msg}
                value={form.message}
                onChange={(e) => setForm({...form, message: e.target.value})}
                required
            ></textarea>

            <button type="submit">{t.contactme.send}</button>
        </form>
    </div>

);
};